/* ============
 * Country Module Mutations
 * ============
 */

import { FETCH_COUNTRIES } from './../../mutation-types';

export default {
  [FETCH_COUNTRIES](state, { countries, pagination }) {
    state.all = countries;
    state.pagination = pagination;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/country/mutations.js